import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tiles } from '../colorTiles';

const ChoicePanel = ({ color, handleSelect, id, defaultMessage }) => {
  return (
    <div className="quiz-item-colors__hair">
      <h3>
        <FormattedMessage id={id} defaultMessage={defaultMessage} />
      </h3>
      <Tiles data={color} onColorSelect={handleSelect} />
    </div>
  );
};

export default ChoicePanel;
